import { TopicRouteImport } from './Import'
const { RoutesMap, TopicList, AddTopic, UpdateTopic, TopicQuestionList, AddTopicQuestion } = TopicRouteImport

const TopicRoute = () => {
    return [
        {
            path: RoutesMap.TOPIC_LIST.path,
            element: <TopicList />
        },
        {
            path: RoutesMap.ADD_TOPIC.path,
            element: <AddTopic />
        },
        {
            path: RoutesMap.UPDATE_TOPIC.path,
            element: <UpdateTopic />
        },
        {
            path: RoutesMap.TOPIC_QUESTION_LIST.path,
            element: <TopicQuestionList />
        },
        {
            path: RoutesMap.ADD_TOPIC_QUESTION.path,
            element: <AddTopicQuestion />
        },
    ]
}

export default TopicRoute
